import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { ExperienceData, HotelData, MuseumData, NccData, TripData } from '../../../models';

// Load all entities for trip output
export const loadTripOutputEntities = createAction(
  '[Trip Output] Load All Entities',
  props<{ trip: TripData }>()
);

export const loadTripOutputEntitiesSuccess = createAction(
  '[Trip Output] Load All Entities Success',
  props<{
    hotels: HotelData[];
    experiences: ExperienceData[];
    nccServices: NccData[];
    museums: MuseumData[];
  }>()
);

export const loadTripOutputEntitiesFail = createAction(
  '[Trip Output] Load All Entities Fail',
  props<{ error: HttpErrorResponse }>()
);

// Clear cached entities
export const clearTripOutputEntities = createAction(
  '[Trip Output] Clear All Entities'
);

// Individual entity loading actions (for granular control if needed)
export const loadHotelsForTrip = createAction(
  '[Trip Output] Load Hotels',
  props<{ hotelIds: string[] }>()
);

export const loadExperiencesForTrip = createAction(
  '[Trip Output] Load Experiences',
  props<{ experienceIds: string[] }>()
);

export const loadNccServicesForTrip = createAction(
  '[Trip Output] Load NCC Services',
  props<{ nccIds: string[] }>()
);

export const loadMuseumsForTrip = createAction(
  '[Trip Output] Load Museums',
  props<{ museumIds: string[] }>()
);
